import { replace } from 'redux-first-history';

import config from '@/config';
import { logger } from '@/config/logger';
import { me } from '@/modules/api/codegen';
import { getStore } from '@/services/context';
import { ErrorCode, isApiAntonioError } from '@/services/utilities/isApiError';

import { authUserSchema } from '../../schemas/oauth';
import { updateAuthInfo } from '../slices/auth';

export async function fetchAuthUser(accessToken: string) {
    try {
        const userResponse = await me({
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            cache: 'no-store',
        });

        const parsedUser = authUserSchema.parse(userResponse.data);

        const { dispatch } = await getStore();

        dispatch(updateAuthInfo(parsedUser));

        return parsedUser;
    } catch (error) {
        if (isApiAntonioError(error)) {
            const handledErrors = new Set<string>([
                ErrorCode.CONFIGURED_SUPER_ADMIN_IS_NOT_AN_ADMIN,
                ErrorCode.CONFIGURED_SUPER_ADMIN_USER_DOESNT_EXIST_IN_THE_WORKSPACE,
                ErrorCode.AUTH_CLIENT_IS_NOT_CONFIGURED,
            ]);

            if (error.data.errorCode && handledErrors.has(error.data.errorCode)) {
                const store = await getStore();

                store.dispatch(
                    replace(
                        `${config.routes.home}?${new URLSearchParams({
                            errorCode: error.data.errorCode,
                        })}`,
                    ),
                );
            }
        }

        logger.error(error);

        throw error;
    }
}
